export default class CaseNoteTag {
  tagId?: number;
  name?: string | null;
  description?: string | null;
  sequence?: number | null;

  public constructor(params: CaseNoteTag = {} as CaseNoteTag) {
    let { tagId = 0, name = "", description = "", sequence = null } = params;
    this.tagId = tagId;
    this.name = name;
    this.description = description;
    this.sequence = sequence;
  }
}
